import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/infra/user/user.service';
import { VersionService } from 'src/app/services/infra/version/version.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
})
export class UserComponent {
  public version: string;

  constructor(
    public userService: UserService,
    private readonly _router: Router,
    private readonly _versionService: VersionService
  ) {
    this.version = this._versionService.version;
  }

  public get userRoles(): string[] {
    return this.userService.apiUserRoles;
  }

  public get hasRoles(): boolean {
    return this.userRoles.length > 0;
  }

  public get isAdmin(): boolean {
    return this.userRoles.length === 1 && this.userRoles[0]?.toLowerCase() === 'admin';
  }

  public get hasMultipleRoles(): boolean {
    return !this.isAdmin && this.userRoles.length > 1;
  }

  public get displayRole(): string {
    return this._capitalizeFirstLetter(this.userRoles[0] ?? '');
  }

  public get additionalRolesCount(): number {
    return this.hasMultipleRoles ? this.userRoles.length - 1 : 0;
  }

  public get additionalRolesTooltip(): string {
    if (!this.hasMultipleRoles) {
      return '';
    }
    return this.userRoles
      .slice(1)
      .map((role) => this._capitalizeFirstLetter(role))
      .join(', ');
  }

  public get roleLabel(): string {
    return this.hasMultipleRoles ? 'menu.roles' : 'menu.role';
  }

  private _capitalizeFirstLetter(text: string): string {
    if (!text) {
      return '';
    }
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  public logout(): void {
    this.userService.logout();
    this._router.navigateByUrl('/login');
  }
}
